export enum PurchasingContractingENUM {
  PURCHASING = "compras",
  CONTRACTING = "contratacao",
}
